import {
  SurveyBuilderRootDocument,
  SurveyBuilderVersionDocument,
} from "@max/common/dist/setfan";
import { DocumentReference, doc, getFirestore } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { useRef } from "react";

const useLastResolved = <T>(value: T | undefined) => {
  const lastResolved = useRef(value);

  if (value !== undefined) {
    lastResolved.current = value;
  }

  return value ?? lastResolved.current;
};

export const useSurveyBuilder = (surveyId: string) => {
  const [survey, isLoadingSurvey] = useDocument(
    doc(
      getFirestore(),
      `set_fan_builder_surveys/${surveyId}`,
    ) as DocumentReference<SurveyBuilderRootDocument>,
  );

  const docRef = survey
    ? (doc(
        getFirestore(),
        `${survey.ref.path}/versions/${survey.data().draftId}`,
      ) as DocumentReference<SurveyBuilderVersionDocument>)
    : null;

  const [liveVersion, isLoadingVersion] = useDocument(docRef);
  const version = useLastResolved(liveVersion);

  const publishedId = survey?.data()?.publishedId;
  const publishedRef =
    survey && publishedId
      ? (doc(
          getFirestore(),
          `${survey.ref.path}/versions/${publishedId}`,
        ) as DocumentReference<SurveyBuilderVersionDocument>)
      : null;

  const [livePublishedVersion] = useDocument(publishedRef);
  const publishedVersion = useLastResolved(livePublishedVersion);
  const isPublishedVersionPending = !!publishedId && !publishedVersion;

  return {
    survey,
    version,
    publishedVersion,
    isLoading:
      isLoadingSurvey ||
      (isLoadingVersion && !version) ||
      isPublishedVersionPending,
  };
};
